import instance from '@/services/repository';

const resource = '/articles';

export default {
    get() {
        return instance.get(`${resource}`);
    },
    create(payload: any) {
        return instance.post(`${resource}`, payload);
    },
    update(payload: any) {
        payload.defaultPrice = null;
        return instance.put(`${resource}/${payload.id}`, payload);
    },
    delete(payload: any) {
        return instance.delete(`${resource}/${payload.id}`);
    },
};
